import { UseCase } from '@app/core/utils/use-case.utility';
import { AuditLogCategory, ConfigurationAuditLogRepository } from '@app/domain';
import { Observable } from 'rxjs';

export class GetAuditLogTaskNamesUseCase
  implements UseCase<AuditLogCategory, string[]>
{
  readonly SERVICE_NAME = 'GetAuditLogTaskNamesUseCase';

  constructor(
    private readonly _configurationAuditLogRepository: ConfigurationAuditLogRepository
  ) {}

  execute(category: AuditLogCategory): Observable<string[]> {
    return this._configurationAuditLogRepository.getAuditLogTaskNames(category);
  }
}
